import React from 'react'

import { FileDetailIconProps } from './excel-drop-area.types'

const FileDetailIcon = (props: FileDetailIconProps) => {
  let cssClass = 'fileStatic'

  if (props.loading) {
    cssClass = 'fileLoading'
  } else if (props.result?.isError) {
    cssClass = 'fileError'
  } else if (!props.result?.isError) {
    cssClass = 'fileSuccess'
  }

  return (
    <div className={`${cssClass}`} id='fileDetailIcon'>
      {props.loading && <span id='loadingIcon'></span>}
      {!props.loading && !props.result && (
        <span id='playIcon' onClick={props.playClickedFunction}>
          ▶
        </span>
      )}
      {props.result && props.result.isError && <span id='errorIcon'>✕</span>}
      {props.result && !props.result.isError && <span id='completeIcon'>✓</span>}

    </div>
  )
}

export default FileDetailIcon
